import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { PageNotFoundComponent } from "./modules/pagenotfound/page-not-found.component";
import { LoginComponent } from "./modules/login/components/login.component";
import { LoginModule } from "./modules/login/login.module";
import { LoginPageComponent } from "./modules/login/login-page/login-page.component";
import { LoginPageSSOComponent } from "./modules/login/login-page-sso/login-page-sso.component";
import { SuPasswordResetComponent } from "./modules/login/su-password-reset/su-password-reset.component";

const routes: Routes = [
	{
		path: "login",
		component: LoginPageComponent,
	},
	{
		path: "login/:ErrorB64",
		component: LoginPageComponent,
	},
	{
		path: "loginSSO/:SSOData",
		component: LoginPageSSOComponent,
	},
	{
		path: "supasswordreset/:SULink",
		data: { name: "supasswordresetroute" },
		component: SuPasswordResetComponent,
	},
	//
	// NOTE: Password Reset is handled by an old ASP.NET MVC/razor page app (Don't need an angular page)
	//
	{ path: "**", component: PageNotFoundComponent },
];

@NgModule({
	imports: [
		LoginModule,
		RouterModule.forRoot(routes, {
			useHash: true,
			// relativeLinkResolution: "legacy",
		}),
	],
	exports: [RouterModule],
	providers: [],
})
export class AppRoutingModule {}
